import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaUserEdit, FaSignOutAlt, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './Home.css';

function Home() {
  const [username, setUsername] = useState('');
  const [ideas, setIdeas] = useState([]);
  const [expandedIdeaId, setExpandedIdeaId] = useState(null); // Estado para expansão
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const name = localStorage.getItem('userName');
    const colaboradorId = localStorage.getItem('colaboradorId');

    if (!token || !colaboradorId) {
      navigate('/login');
    } else {
      setUsername(name || 'Usuário');
      fetchIdeas(parseInt(colaboradorId, 10));
    }
  }, [navigate]);

  const fetchIdeas = async (colaboradorId) => {
    try {
      const response = await fetch('https://rh.sagresrg.com.br/ideias', {
        method: 'GET',
        headers: {
          'Authorization': 'Basic d37b2b5124b3203aac517b47c1d33a475a075fd0c797347b22893e9c2303',
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (data.status === 'success') {
        const userIdeas = data.data.filter((idea) => idea.colaboradores_id === colaboradorId);
        setIdeas(userIdeas);
      } else {
        console.error('Erro ao buscar ideias:', data);
      }
    } catch (error) {
      console.error('Erro na chamada da API de ideias:', error);
    }
  };

  const getStatusText = (statusId) => {
    switch (statusId) {
      case 1:
        return 'Pendente RH';
      case 2:
        return 'Classificada';
      case 3:
        return 'Finalizada';
      case 4:
        return 'Pendente Gestor';
      default:
        return 'Desconhecido';
    }
  };

  const getStatusClass = (statusId) => {
    switch (statusId) {
      case 1:
        return 'status-pendente-rh';
      case 2:
        return 'status-classificada';
      case 3:
        return 'status-finalizada';
      case 4:
        return 'status-pendente-gestor';
      default:
        return 'status-desconhecido';
    }
  };

  const getStatusMessage = (statusId) => {
    switch (statusId) {
      case 1:
        return 'Sua ideia está com o RH aguardando análise.';
      case 2:
        return 'Sua ideia foi avaliada pelo RH e classificada.';
      case 3:
        return 'Sua ideia foi finalizada após todas as análises.';
      case 4:
        return 'Sua ideia foi enviada e aguarda análise do gestor responsável.';
      default:
        return '';
    }
  };

  const toggleExpanded = (id) => {
    setExpandedIdeaId((prev) => (prev === id ? null : id));
  };

  const handleNovaIdeiaClick = () => {
    navigate('/nova-ideia');
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userName');
    localStorage.removeItem('colaboradorId');
    navigate('/login');
  };

  return (
    <div className="home-container">
      <div className="welcome-card">
        <h1>Bem-vindo, {username}!</h1>
        <div className="icon-buttons">
          <button onClick={handleNovaIdeiaClick} className="icon-card">
            <FaPlus />
            <p>Nova Ideia</p>
          </button>
          <button className="icon-card">
            <FaUserEdit />
            <p>Perfil</p>
          </button>
          <button onClick={handleLogout} className="icon-card">
            <FaSignOutAlt />
            <p>Sair</p>
          </button>
        </div>
      </div>

      <div className="ideas-list">
        <h2>Lista de Ideias</h2>
        <table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {ideas.length > 0 ? (
              ideas.map((idea) => (
                <React.Fragment key={idea.id}>
                  <tr className="idea-row">
                    <td>{idea.descricao}</td>
                    <td>
                      <span
                        className={`status-label ${getStatusClass(idea.status_ideias_id)}`}
                        title={getStatusMessage(idea.status_ideias_id)}
                      >
                        {getStatusText(idea.status_ideias_id)}
                      </span>
                      {idea.status_ideias_id === 3 && (
                        <button
                          className="expand-button"
                          onClick={() => toggleExpanded(idea.id)}
                          title="Ver detalhes"
                        >
                          {expandedIdeaId === idea.id ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      )}
                    </td>
                  </tr>
                  {expandedIdeaId === idea.id && (
                    <tr className="expanded-row">
                      <td colSpan="2">
                        <div className="expanded-content">
                          <strong>Ideia avaliada pelo RH e gestor:</strong>
                          <p>{idea.motivo || 'Sem motivo registrado.'}</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="2">Nenhuma ideia encontrada para este colaborador.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Home;
